import { useEffect, useState, type ReactNode } from 'react'
import { AppBootLoading } from '../components/AppBootLoading'
import { maybeHandleOidcCallback } from '../platform/auth/oidc'

function needsOidcCallbackHandling(): boolean {
  const url = new URL(window.location.href)
  if (url.pathname.endsWith('/auth/callback')) return true
  return url.searchParams.has('code') && url.searchParams.has('state')
}

type OidcBootstrapGateProps = {
  children: ReactNode
}

/** Finishes OIDC redirect callback work under a loading shell instead of blocking React mount. */
export function OidcBootstrapGate({ children }: OidcBootstrapGateProps) {
  const [oidcReady, setOidcReady] = useState(() => !needsOidcCallbackHandling())

  useEffect(() => {
    if (oidcReady) return
    let mounted = true
    void maybeHandleOidcCallback()
      .catch(() => {
        /* Non-fatal: user can retry login. */
      })
      .finally(() => {
        if (mounted) setOidcReady(true)
      })
    return () => {
      mounted = false
    }
  }, [oidcReady])

  if (!oidcReady) {
    return <AppBootLoading label="Signing in…" />
  }

  return children
}
